import { Copy, Download } from "lucide-mui";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { copyToClipboard } from "../utils/clipboard.ts";

interface BackupCodesListProps {
  codes: string[];
}

const FILENAME = "vayken-backup-codes.txt";

function download(codes: string[]) {
  const text = [
    "Vayken backup codes",
    "Each code signs you in once when you can't use your authenticator app.",
    "",
    ...codes,
    "",
  ].join("\n");
  const url = URL.createObjectURL(new Blob([text], { type: "text/plain" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = FILENAME;
  a.click();
  URL.revokeObjectURL(url);
}

/** One-time recovery codes, shown once: a grid to read, copy or download. */
export default function BackupCodesList({ codes }: BackupCodesListProps) {
  return (
    <Stack spacing={1.5}>
      <Box
        component="ol"
        sx={{
          m: 0,
          p: 2,
          listStyle: "none",
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          rowGap: 1,
          columnGap: 3,
          bgcolor: "action.hover",
          border: 1,
          borderColor: "divider",
          borderRadius: 1,
          fontFamily: "monospace",
          fontSize: "0.9375rem",
          letterSpacing: "0.08em",
          textAlign: "center",
        }}
      >
        {codes.map((c) => (
          <li key={c}>{c}</li>
        ))}
      </Box>
      <Stack direction="row" spacing={1}>
        <Button
          size="small"
          variant="outlined"
          startIcon={<Copy />}
          onClick={() => copyToClipboard(codes.join("\n"), "Backup codes copied")}
        >
          Copy all
        </Button>
        <Button size="small" variant="outlined" startIcon={<Download />} onClick={() => download(codes)}>
          Download
        </Button>
      </Stack>
    </Stack>
  );
}
